import { GatewayStatus } from 'constants/gatewayStatuses';

import { Tooltip } from '@mui/material';
import { ReactComponent as PilotIcon } from 'images/pilotFilled.svg';
import { RaRecord, useGetList } from 'react-admin';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { GatewayStatus as GatewayStatusType } from 'types/embedded/gateway';

import {
  CheckIconStyled,
  DoNotDisturbAltIconStyled,
  TitleIconStyled,
} from './GatewayStatusIconField.styled';

export type GatewayStatusIconFieldProps = Omit<FunctionFieldProps, 'render'>;

const statusIcons: Record<GatewayStatus, JSX.Element> = {
  [GatewayStatus.Active]: <CheckIconStyled />,
  [GatewayStatus.Disabled]: <DoNotDisturbAltIconStyled />,
  [GatewayStatus.Test]: <TitleIconStyled />,
  [GatewayStatus.Pilot]: <PilotIcon style={{ width: 20, height: 20 }} />,
};

export const GatewayStatusIconField = (props: GatewayStatusIconFieldProps): JSX.Element => {
  const { data: gatewayStatuses } = useGetList<GatewayStatusType>('gateway_statuses');

  return (
    <FunctionField
      {...props}
      render={(record: RaRecord & { status?: any }) => {
        const status = record?.status?.value as GatewayStatus | undefined;

        if (!status) {
          return <DoNotDisturbAltIconStyled />;
        }

        const icon = statusIcons[status] ?? <DoNotDisturbAltIconStyled />;
        const description = gatewayStatuses?.find(
          (gatewayStatus) => gatewayStatus?.value === status,
        )?.description;

        return (
          <Tooltip title={description ?? 'Неизвестно'}>
            <span>{icon}</span>
          </Tooltip>
        );
      }}
    />
  );
};
